import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import CardsPersonal from 'system/cards-personal';
import Spinner from '../../../spinner';

import {loadStaffByTypes} from 'redux/actions/portal/institutions';

import doctor from 'images/general/doctor.svg';

const mapStateToProps = state => ({
  staff: state.institutions.get('institutionPersonal')
});

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(loadStaffByTypes('0400,0100', "2"))
});

class TimeTable extends Component {

  componentWillMount() {
    this.props.onLoad();
  }

  render() {

    if (this.props.staff === undefined || (!this.props.staff.get('results'))) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      );
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
          <li><Link to="/health-management/timetable">Графік прийому</Link></li>

        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Графік прийому</h2>

            {this.props.staff.get('results').size > 0 ? (

              <CardsPersonal>
                {this.props.staff.get('results').map((item, i) => (
                  <li key={i}>
                      <Link to={`/health-management/timetable/detail/${item.get('id')}`}>
                          {item.get('user_data').get('photo') ? (
                              <div style={{width: "60%", backgroundImage: `url(${item.get('user_data').get('photo')})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
                          ):(
                              <div style={{width: "60%", backgroundImage: `url(${doctor})`, backgroundSize: "150px", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}> </div>
                          )}
                          <div>
                      <h3>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')} </h3>
                      <p><span>Посада: </span>{item.get('position_title')}</p>
                          </div>

                    </Link>
                  </li>
                ))}
              </CardsPersonal>
            ):(
              <h3>Фахівці відсутні</h3>

            )}
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(TimeTable));



// WEBPACK FOOTER //
// ./src/system/management/timetable/index.js